module.exports = __webpack_public_path__ + "static/media/pr3.cdea8050.jpg";